import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-search-2-line',
    title: 'Strategic Sourcing & Supplier Intelligence',
    color: 'bg-emerald-700',
    items: [
      {
        label: 'Targeted Identification',
        detail:
          'Pinpointing reputable, high-quality global sources that align with your specific technical requirements.',
      },
      {
        label: 'Rigorous Vetting',
        detail:
          'Multi-stage screening of potential suppliers to isolate only the most viable, stable, and collaborative options.',
      },
      {
        label: 'Facility Pre-Qualification',
        detail:
          'On-site and remote evaluation of facilities, product specifications, and the solicitation of physical samples and technical dossiers.',
      },
    ],
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Regulatory Compliance & Quality Assurance',
    color: 'bg-teal-700',
    items: [
      {
        label: 'Compliance Auditing',
        detail:
          'Detailed evaluation of product and facility alignment with global regulatory standards.',
      },
      {
        label: 'Canadian DMF Representation',
        detail:
          'Acting as a localized Drug Master File (DMF) agent for the Canadian market.',
      },
      {
        label: 'Audit Coordination',
        detail:
          'Seamless management of both internal client audits and external regulatory inspections.',
      },
      {
        label: 'Documentation Management',
        detail:
          'Comprehensive gathering and verification of all supporting technical and safety documentation.',
      },
    ],
  },
  {
    icon: 'ri-user-voice-line',
    title: 'Executive Liaison & Communication Shielding',
    color: 'bg-stone-700',
    items: [
      {
        label: 'Strategic Intermediary',
        detail:
          'We act as your primary filter, shielding you from excessive or "abusive" supplier communications and maintaining total confidentiality until you are ready to proceed.',
      },
      {
        label: 'Cross-Border Coordination',
        detail:
          'Bridging language barriers and managing complex time-zone logistics for 24/7 responsiveness.',
      },
      {
        label: 'Global Representation',
        detail:
          'Providing professional representation for suppliers and coordinating high-stakes meetings, international site visits, and factory tours.',
      },
    ],
  },
  {
    icon: 'ri-truck-line',
    title: 'Logistics & Contract Architecture',
    color: 'bg-emerald-800',
    items: [
      {
        label: 'Negotiation Excellence',
        detail:
          'Securing optimal pricing and favorable supply conditions through expert contract architecture.',
      },
      {
        label: 'End-to-End Logistics',
        detail:
          'Managing the planning, transport, and customs clearance of goods across international borders.',
      },
      {
        label: 'Supply Chain Planning',
        detail:
          'Coordinating production schedules and delivery requirements to ensure lean, just-in-time operations.',
      },
    ],
  },
];

export default function ServicesSection() {
  return (
    <section className="w-full bg-stone-50 py-20 px-6 md:px-16">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-emerald-600 text-xs font-bold uppercase tracking-widest">What We Do</span>
          <h2
            className="text-4xl md:text-5xl font-extrabold text-stone-800 mt-3"
            style={{ fontFamily: "'DM Serif Display', serif" }}
          >
            Comprehensive Global Sourcing &amp; Regulatory Services
          </h2>
          <p className="text-gray-500 mt-4 max-w-2xl mx-auto text-base">
            Full-spectrum sourcing solutions for pharmaceutical and fine chemical industries worldwide.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {services.map((s, idx) => (
            <div
              key={idx}
              className="bg-white rounded-lg overflow-hidden border border-stone-100 hover:-translate-y-1 transition-transform duration-200"
            >
              <div className={`${s.color} px-6 py-5 flex items-center gap-4`}>
                <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-md">
                  <i className={`${s.icon} text-white text-xl`} />
                </div>
                <h3 className="text-white font-bold text-base leading-tight">{s.title}</h3>
              </div>
              <div className="px-6 py-5 space-y-3">
                {s.items.map((item, i) => (
                  <div key={i} className="flex gap-3">
                    <div className="mt-1 w-4 h-4 flex items-center justify-center flex-shrink-0">
                      <i className="ri-checkbox-circle-fill text-emerald-600 text-base" />
                    </div>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      <strong className="text-stone-700 font-semibold">{item.label}:</strong>{' '}
                      {item.detail}
                    </p>
                  </div>
                ))}
                <div className="pt-2">
                  <Link
                    to="/services"
                    className="inline-flex items-center gap-1 text-emerald-700 text-sm font-semibold hover:gap-2 transition-all cursor-pointer whitespace-nowrap"
                  >
                    Learn More <i className="ri-arrow-right-line" />
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
